// extracted by mini-css-extract-plugin
var _1 = "NotificationItemV2-module__action--FW2On";
var _2 = "NotificationItemV2-module__actionIcon--kth4a";
var _3 = "NotificationItemV2-module__animateUploadProgressBarWidth--gVgkf";
var _4 = "NotificationItemV2-module__animatedBackground--XQUkz";
var _5 = "NotificationItemV2-module__avatarContainer--PJ6GU";
var _6 = "NotificationItemV2-module__commentIcon--GWpTA";
var _7 = "NotificationItemV2-module__container--NHXN0";
var _8 = "NotificationItemV2-module__contentContainer--_J9Gx";
var _9 = "NotificationItemV2-module__draftIcon--Ts9mp";
var _a = "NotificationItemV2-module__firstRow--wbhZH";
var _b = "NotificationItemV2-module__mutedIcon--SLoVF";
var _c = "NotificationItemV2-module__notificationItem--ZV08V";
var _d = "NotificationItemV2-module__postIcon--bbHS8";
var _e = "NotificationItemV2-module__postTitle--XptSt";
var _f = "NotificationItemV2-module__row--Ok5Ue";
var _10 = "NotificationItemV2-module__secondRow--bXk1y";
var _11 = "NotificationItemV2-module__timestamp--FN_r7";
var _12 = "NotificationItemV2-module__unreadIndicator--UHXkE";
var _13 = "NotificationItemV2-module__verificationReminderIcon--KAvTB";
var _14 = "NotificationItemV2-module__verificationRequestIcon--fYorA";
export { _1 as "action", _2 as "actionIcon", _3 as "animateUploadProgressBarWidth", _4 as "animatedBackground", _5 as "avatarContainer", _6 as "commentIcon", _7 as "container", _8 as "contentContainer", _9 as "draftIcon", _a as "firstRow", _b as "mutedIcon", _c as "notificationItem", _d as "postIcon", _e as "postTitle", _f as "row", _10 as "secondRow", _11 as "timestamp", _12 as "unreadIndicator", _13 as "verificationReminderIcon", _14 as "verificationRequestIcon" }
